"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateRangeCalendarFilters = void 0;
const getDateRangeCalendarFilters = (fieldSlug, startPeriod, endPeriod) => {
    const fromDateSlug = `${fieldSlug}.from_date`;
    const toDateSlug = `${fieldSlug}.to_date`;
    return {
        is_group: true,
        operator: "or",
        conditions: [
            // period overlaps from_date
            // view : |------|
            // value:    |------|
            {
                is_group: true,
                operator: "and",
                conditions: [
                    {
                        field: fromDateSlug,
                        comparison: "is_not_empty",
                        value: null,
                    },
                    {
                        field: fromDateSlug,
                        comparison: "is",
                        value: {
                            date_mode: "date_range",
                            date_mode_value: {
                                lower: startPeriod,
                                upper: endPeriod,
                                bounds: "[]",
                            },
                        },
                    },
                ],
            },
            // period overlaps to_date
            // view :    |------|
            // value: |------|
            {
                is_group: true,
                operator: "and",
                conditions: [
                    {
                        field: toDateSlug,
                        comparison: "is_not_empty",
                        value: null,
                    },
                    {
                        field: toDateSlug,
                        comparison: "is",
                        value: {
                            date_mode: "date_range",
                            date_mode_value: {
                                lower: startPeriod,
                                upper: endPeriod,
                                bounds: "[]",
                            },
                        },
                    },
                ],
            },
            // period less than a date range value
            // view :   |--|
            // value: |------|
            {
                is_group: true,
                operator: "and",
                conditions: [
                    {
                        field: toDateSlug,
                        comparison: "is_not_empty",
                        value: null,
                    },
                    {
                        field: fromDateSlug,
                        comparison: "is_not_empty",
                        value: null,
                    },
                    {
                        field: fromDateSlug,
                        comparison: "is_on_or_before",
                        value: {
                            date_mode: "exact_date",
                            date_mode_value: startPeriod,
                        },
                    },
                    {
                        field: toDateSlug,
                        comparison: "is_on_or_after",
                        value: {
                            date_mode: "exact_date",
                            date_mode_value: endPeriod,
                        },
                    },
                ],
            },
        ],
    };
};
exports.getDateRangeCalendarFilters = getDateRangeCalendarFilters;
